import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash.isempty';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import moment from 'moment'
import {
  Grid, Button,
} from '@material-ui/core';
import { GetResourePlanningExl } from './resourcePlanningAction';
import OverLoader from '../../components/common/loader';
import { LogoutAction } from '../../actions';

const dateFormat = 'YYYY';

class ResourcePlanning extends Component {

  state = {
    yearField: new Date().getFullYear(),

  }


  componentDidMount = () => {
    const { GetResourePlanningExl } = this.props
    const { yearField } = this.state
    GetResourePlanningExl(yearField)
  }

  yearFieldHandleChange = (e) => {
    const { GetResourePlanningExl } = this.props
    if (e !== null) {
      let date = moment(e._d).format("YYYY");
      this.setState({ yearField: date, consultant_pdf: '' }, () => GetResourePlanningExl(date))
    } else {
      this.setState({ yearField: '' })
    }
  }

  render() {
    const { yearField } = this.state
    const { isloading, resource_planning } = this.props
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div className="plainingTab plainingTab-action">
        {isloading && <OverLoader />}
        <Fragment>
          <Grid container spacing={2}>
            <Grid item xs={2} className="inner-p-label">
              <div className="innermeLable">Jahr</div>
              <DatePicker
                value={yearField === "" ? '' : moment(yearField, dateFormat)}
                format={dateFormat}
                allowClear={false}
                bordered={false}
                onChange={(e) => {
                  this.yearFieldHandleChange(e)
                }}
                picker="year" />
            </Grid>
            {!isEmpty(resource_planning) &&
              <Grid item xs={4} className="inner-p-label">
                {/* <a href={customerOverviewPdf} target="_blank"> */}
                <Button variant="outlined" color="primary"
                  onClick={() => {
                    const theLink = document.createElement('a');
                    theLink.href = resource_planning;
                    theLink.download = "Ressourcenplanung_" + yearField + ".xlsx";
                    document.body.appendChild(theLink);
                    theLink.click();
                    document.body.removeChild(theLink);
                  }
                  }
                >Drucken</Button>
                {/* </a> */}
              </Grid>
            }

          </Grid>
        </Fragment>
      </div>
    )
  }
}

const mapStateToProps = ({ resource }) => {
  return {
    resource_planning: resource.resource_planning,
    isloading: resource.loading,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetResourePlanningExl: (year) => dispatch(GetResourePlanningExl(year)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ResourcePlanning)